// extracted by mini-css-extract-plugin
export default {"divider":"ButtonDrawerDivider__divider___dOo_u"};